var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAccountPink = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "512pt",
  height: "512pt",
  viewBox: "0 0 512 512"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M512 256C512 114.512 397.504 0 256 0 114.512 0 0 114.496 0 256c0 140.234 113.54 256 256 256 141.875 0 256-115.121 256-256M256 30c124.617 0 226 101.383 226 226 0 45.586-13.559 89.402-38.703 126.516-100.969-108.61-273.442-108.805-374.594 0C43.56 345.402 30 301.586 30 256 30 131.383 131.383 30 256 30M87.414 406.5c89.774-100.695 247.422-100.672 337.168 0-90.074 100.773-247.055 100.805-337.168 0m0 0"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M256 271c49.625 0 90-40.375 90-90v-30c0-49.625-40.375-90-90-90s-90 40.375-90 90v30c0 49.625 40.375 90 90 90m-60-120c0-33.086 26.914-60 60-60s60 26.914 60 60v30c0 33.086-26.914 60-60 60s-60-26.914-60-60zm0 0"
})));
export default SvgAccountPink;